import { Link } from 'react-router-dom';
import { seoArticles } from '@/mocks/categories';

export default function SEOArticlesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-xs font-label uppercase tracking-[0.2em] text-foreground-500 mb-3">
            Learn &amp; Master
          </p>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            LitBuy Spreadsheet Guides
            <br />
            <span className="text-primary-500">Expert Articles for Smarter Shopping</span>
          </h2>
          <p className="mt-4 text-sm text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            Dive into our collection of in-depth articles covering everything from beginner
            basics to advanced techniques. Each guide is crafted to help you get the most 
            out of your litbuy spreadsheet experience.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {seoArticles.map((article) => (
            <Link
              key={article.id}
              to={`/${article.id}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:shadow-md transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="w-full h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-[10px] font-label font-semibold uppercase tracking-wider bg-accent-100 text-accent-800 px-2 py-0.5 rounded-full">
                    Guide
                  </span>
                  <span className="text-[10px] text-foreground-500">{article.readTime}</span>
                </div>
                <h3 className="text-base font-label font-semibold text-foreground-950 mb-2 leading-snug group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed flex-1">
                  {article.excerpt}
                </p>
                <div className="mt-3 flex items-center gap-1 text-xs text-primary-500 font-label font-medium">
                  Read Article
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-[10px]"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}